module.exports = __webpack_public_path__ + "static/preview1-9a8448ce6be2483461e12fd935f6390b.jpg";